import { combineReducers } from 'redux';
import applicationReducer from 'application/applicationReducer';
import submissionReducer from 'submission/submissionReducer';
import introductionReducer from 'introduction/introductionReducer';
import optionsReducer from 'options/optionsReducer';
import contactInfoReducer from 'contact-info/contactInfoReducer';
import dissertationInfoReducer from 'dissertation-info/dissertationInfoReducer';
import fileUploadReducer from 'file-upload/fileUploadReducer';
import reviewReducer from 'review/reviewReducer';

export default combineReducers({
  application: applicationReducer,
  submission: submissionReducer,
  introduction: introductionReducer,
  options: optionsReducer,
  contactInfo: contactInfoReducer,
  dissertationInfo: dissertationInfoReducer,
  fileUpload: fileUploadReducer,
  review: reviewReducer,
});



// WEBPACK FOOTER //
// ./src/root/rootReducer.js